/*
 * @Author: Scarlett Xiao
 * @Date: 2022-03-16 11:07:10
 * @LastEditors: Scarlett Xiao
 * @LastEditTime: 2022-03-17 11:36:14
 */
import store from "@/store";

export function getUyuDomain() {
  let uyuHost = '';
  uyuHost = store.state.hostReturnPath ? store.state.hostReturnPath : `${this.getHost()}#/login`;
  return uyuHost;
}
/**
 * 项目域名拼接
 */
export function getHost() {
  const protocol = window.location.protocol;
  const hostname = window.location.hostname;
  const host = window.location.host;
  let domain = "";
  if (hostname.indexOf("localhost") > -1) { // 开发版
    domain = "http://localhost:4200/";
  }
  // 外网测试
  // if (hostname == "desktop-test.uyu1027.com") {
  //   domain = "http://ufish-admin-test-v2.uyu1027.com/";
  // }
  // 外网预上线
  if (hostname == "desktop-test.uyu1027.com") {
    domain = "http://ufish-admin-pre.uyu1027.com/";
  }
  // 正式版
  if (hostname == "desktop.uyu1027.com") {
    domain = (protocol ? protocol : 'https:') + "//ufish-admin.uyu1027.com/";
  }
  return domain;
}
// 退出
export function doExit() {
  const path = store.state.hostReturnPath ? store.state.hostReturnPath : `${this.getHost()}#/login`;
  return ['ZHANYU', 'LIANTONG'].includes(store.state.hostLabel) ? path : `${this.getHost()}#/login`;
}
/**
 * @brief: 获取一级域名+后缀
 * @author: Scarlett Xiao
 * @Date: 2021-12-09 10:16:41
 */
export function getDomain() {
  let cookie_main = '';
  const isDev = window.location.hostname === 'localhost' ? true : false;
  if (isDev) {
    cookie_main = 'localhost';
  } else if (window.location.hostname.indexOf('.uyu.com') > -1) {
    cookie_main = 'uyu.com';
  } else if (window.location.hostname.indexOf('.uyu1027.com') > -1) {
    cookie_main = 'uyu1027.com';
  }
  return cookie_main;
}
// 获取iot跳转平台的url
export function getIOTPath() {
  const hostname = window.location.hostname;
  const protocol = window.location.protocol;
  let url = null;
  if (hostname == "localhost") {
    // 开发版
    url = "http://localhost:8080/";
  }
  // 新域名
  else if (hostname == "view-test.uyu1027.com") {
    // 外网测试版
    url = (protocol ? protocol : "https:") + "//iot-test.uyu1027.com/";
  } else if (hostname == "view.uyu1027.com") {
    // 正式版
    url = (protocol ? protocol : "https:") + "//iot.uyu1027.com/";
  }
  return url;
}